<template>
    <div>
        <div>
            <BirthdayBalloons v-if="teacher.show_birthday_balloons" />
        </div>

        <div class="bg-white shadow">
            <div class="px-4 sm:px-6 lg:max-w-6xl lg:mr-auto lg:px-8">
                <div class="py-6 md:flex md:items-center md:justify-between lg:border-t lg:border-gray-200">
                    <div class="flex-1 min-w-0 flex items-center space-x-2">
                        <div class="flex items-center">
                            <img
                                :src="teacher.avatar_or_default"
                                class="hidden h-16 w-16 rounded-full sm:block"
                                alt=""
                            />
                            <div>
                                <div class="flex items-center">
                                    <img
                                        :src="teacher.avatar_or_default"
                                        alt="Foto de perfil"
                                        class="h-16 w-16 rounded-full sm:hidden"
                                    />
                                    <h1
                                        class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate"
                                    >
                                        <template v-if="teacher.is_birthday">
                                            🎂
                                            {{
                                                $t('messages.happy_birthday_message', {
                                                    name: teacher.name_or_nickname,
                                                })
                                            }}
                                        </template>
                                        <template v-else>
                                            {{
                                                $t('messages.good_morning', {
                                                    name: teacher.name_or_nickname,
                                                })
                                            }}
                                        </template>
                                    </h1>
                                </div>
                                <dl class="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                                    <dt class="sr-only">Rol</dt>
                                    <dd class="flex items-center text-sm text-gray-500 font-medium capitalize sm:mr-6">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            aria-hidden="true"
                                            class="shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                        {{ $tc('messages.teachers', 1) }}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                        <div v-if="teacher.dashboard_badge" class="h-16 w-16">
                            <img :src="teacher.dashboard_badge" alt="" class="object-contain" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-8" v-if="announcements.length > 0">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow rounded-lg md:col-span-6">
                    <div class="px-4 py-5 sm:p-6">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            {{ $tc('messages.announcements', 2) }}
                        </h3>
                        <div class="mt-5" v-for="announcement in announcements" :key="announcement.id">
                            <div class="rounded-md bg-yellow-50 px-6 py-5 sm:flex sm:items-start sm:justify-between">
                                <div class="sm:flex sm:items-start">
                                    <svg
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        class="information-circle shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition ease-in-out duration-150"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                    <div class="mt-3 sm:mt-0 sm:ml-4">
                                        <div class="text-lg leading-5 font-medium text-gray-900">
                                            {{ announcement.title }}
                                        </div>
                                        <div class="mt-1 text-sm leading-5 text-gray-600 sm:flex sm:items-center">
                                            <div>
                                                <p v-html="announcement.body" class="prose prose-sm" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--        Widgets section-->
        <DashboardTeacherWidgets :widgets="widgets" />
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import DashboardTeacherWidgets from '@/components/DashboardTeacherWidgets.vue';
import BirthdayBalloons from '@/components/pageSpecific/BirthdayBalloons.vue';

export default {
    components: {
        DashboardTeacherWidgets,
        BirthdayBalloons,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'teacher', 'widgets', 'announcements'],
    data() {
        return {};
    },
    methods: {},
};
</script>
<style scoped>
p.prose {
    max-width: 100%;
}
</style>
